function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,2691.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2056ce",
  fillRule: "nonzero",
  d: "M11730 26540 c-887 -49 -1807 -229 -2695 -525 -298 -100 -570 -217 -1007 -436 -1536 -768 -2886 -1836 -4044 -3200 -1359 -1601 -2411 -3579 -3069 -5770 -156 -519 -349 -1404 -449 -2059 -70 -458 -106 -917 -87 -1113 13 -136 30 -139 90 -19 53 106 92 219 155 456 114 423 409 1334 616 1901 492 1352 1074 2565 1746 3643 503 808 1345 1834 2087 2545 993 950 1945 1631 3037 2171 1928 954 3953 1219 5940 775 641 -143 1164 -331 1794 -646 467 -234 1074 -594 1371 -813 251 -185 515 -343 652 -389 68 -23 148 -27 186 -10 97 44 55 276 -109 599 -255 504 -823 1115 -1459 1571 -1061 762 -2245 1187 -3635 1304 -218 19 -890 28 -1120 15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2056ce",
  fillRule: "nonzero",
  d: "M10480 21505 c-660 -75 -1286 -345 -1800 -776 -479 -402 -851 -975 -1024 -1577 -94 -327 -128 -568 -129 -912 -1 -537 99 -975 333 -1455 166 -341 363 -619 630 -885 515 -516 1149 -832 1890 -941 177 -26 556 -36 741 -20 961 88 1833 573 2395 1333 336 455 540 966 620 1553 25 183 25 597 1 787 -53 404 -157 743 -344 1111 -390 768 -1051 1340 -1873 1622 -205 70 -376 111 -610 146 -179 28 -643 35 -830 14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2056ce",
  fillRule: "nonzero",
  d: "M13045 13434 c-150 -89 -536 -279 -730 -359 -712 -295 -1386 -457 -2195 -527 -283 -25 -1156 -12 -1313 18 l-27 6 3 -4994 c3 -5470 -2 -5025 58 -5358 81 -458 259 -867 499 -1151 137 -160 348 -342 516 -442 345 -206 730 -298 1189 -284 209 7 328 22 512 67 370 89 702 282 968 561 388 407 593 978 635 1770 12 228 14 10759 3 10758 -5 0 -57 -30 -118 -65z"
}));

var SvgIndeed = function SvgIndeed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2056ce",
    width: "1854.000000pt",
    height: "2691.000000pt",
    viewBox: "0 0 1854.000000 2691.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIndeed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/indeed.2caad5a3.svg";
export { ForwardRef as ReactComponent };